import type { ReactNode } from "react";
import loginLogo from "../../assets/login-logo.png";
import { FeatureAccordion } from "./FeatureAccordion";
import { LOGIN_TITLE } from "./useHubBranding";
import { WebCanvas } from "./WebCanvas";

/** The pre-login screens' shared 8/4 split: Infinity brand panel on the left, the form on the
    right. Sign-in and invitation acceptance both use it so they look like one product. */
export function AuthSplit({
  title, welcome, children, eyebrow = "Group console", headline = "One place to run e-invoicing for every company.",
}: {
  title: string;
  welcome: string;
  children: ReactNode;
  eyebrow?: string;
  headline?: string;
}) {
  return (
    <main className="signin signin-split">
      <section className="signin-hero">
        <WebCanvas />
        <img className="signin-hero-logo" src={loginLogo} alt={LOGIN_TITLE} />
        <div className="signin-hero-copy">
          <p className="signin-eyebrow">{eyebrow}</p>
          <h2>{headline}</h2>
          <FeatureAccordion />
        </div>
      </section>
      <section className="signin-panel">
        <div className="signin-panel-inner">
          <h1 className="display">{title}</h1>
          <p className="signin-welcome">{welcome}</p>
          {children}
        </div>
      </section>
    </main>
  );
}
